import { Pipe, PipeTransform } from '@angular/core';

type named = { name: string };

@Pipe({
  name: 'sortByName'
})
export class SortByNamePipe implements PipeTransform {

  transform<T extends named>(array: T[], order: 'A->Z' | 'Z->A' = 'A->Z' ): T[] {
    if (order === 'A->Z') {
      return array.sort((a: T,b: T)=> {
        return a.name.localeCompare(b.name);
      });
    } else if (order === 'Z->A') {
      return array.sort((a: T,b: T)=> {
        return b.name.localeCompare(a.name);
      });
    }


    }

}
